module.exports = __webpack_public_path__ + "img/x-octagon.f7caae72.svg";